import { inject, Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { EMPTY, Observable, finalize, tap } from 'rxjs';
import { LoadCountries, LoadCountriesIfNotLoaded } from '@core/locations/store/actions/countries.actions';
import { Country } from '@core/locations/models/country.interface';
import { CountriesService } from '@core/locations/services/countries.service';

export interface CountriesStateModel {
  loading: boolean;
  countries?: Country[];
}

@State<CountriesStateModel>({
  name: 'locationCountries',
  defaults: {
    loading: false,
  },
})
@Injectable()
export class CountriesState {
  private readonly countriesService = inject(CountriesService);

  @Selector()
  static countries(state: CountriesStateModel): Country[] | undefined {
    return state.countries;
  }

  @Selector()
  static loading(state: CountriesStateModel): boolean {
    return state.loading;
  }

  @Action(LoadCountriesIfNotLoaded)
  loadCountriesIfNotLoaded(context: StateContext<CountriesStateModel>): Observable<void> {
    const { countries } = context.getState();
    return countries ? EMPTY : context.dispatch(LoadCountries);
  }

  @Action(LoadCountries)
  loadCountries(context: StateContext<CountriesStateModel>): Observable<Country[]> {
    context.patchState({ loading: true });
    return this.countriesService.getCountries().pipe(
      tap(countries => {
        context.patchState({
          countries,
        });
      }),
      finalize(() => {
        context.patchState({ loading: false });
      })
    );
  }
}
